import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disclaimer-subject-change',
  templateUrl: './disclaimer-subject-change.component.html',
  styleUrls: ['./disclaimer-subject-change.component.scss'],
})
export class DisclaimerSubjectChangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
